/** @format */

import React from "react";

export default function Title({ title, textplacement }) {
  return (
    <div>
      <div id="wrap-title" className="w-11/12 mx-auto my-24">
        <h2
          className={`text-4xl sm:text-5xl lg:text-6xl text-green-800 font-bold mb-8 ${
            textplacement === "right" ? "text-right" : "text-left"
          }`}
        >
          {title}
        </h2>
      </div>
    </div>
  );
}
